// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"0924b195","159":"b9acf860","292":"18c801da","379":"a5fef9e5","607":"5e4a03f5","620":"526edb7f","666":"66267155","759":"147b8220","921":"64f5d52b","957":"61d1f813"}[chunkId] + ".chunk.js";
};